import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, IconButton, InputAdornment } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { TextField } from "@mui/material";
import blogFetch from "../../axios/config";
import { IModalAddGroupProps ,IPermission} from "./GroupPermissionInterfaces";
import { getIdCompany } from "../../utils/constantes";
import language from "../../nls/language.json";
import Context from "../../context/Context";

const ModalAddPermission: React.FC<IModalAddGroupProps> = ({
  open,
  onClose,
  getGroup,
}) => {
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const {
    selectedCountry
  } = useContext(Context);

  const addPermission = async () => {
    setLoading(true);
    try {
      const addPermission: IPermission = {
        Permissions_CompanyId: getIdCompany(),
        permissions_Description: description,
        permissions_Type:"",

      };

      const response = await blogFetch.post(`/permission`, addPermission);
      const data = response.data;
      setTimeout(() => {
        setLoading(false);
      }, 500);
      await getGroup();
      onClose();
      return data;
    } catch (error) {
      console.error(error);
      setTimeout(() => {
        setLoading(false);
      }, 500);

      throw error;
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarPermissao.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <TextField
            className="mb-3"
            id="outlined-basic"
            label="Descrição"
            variant="outlined"
            size="small"
            fullWidth
            name="Descrição"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: "flex", gap: 10 }}>
        <Button variant="text" onClick={onClose}>
          {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarPermissao.btnCancelar}
        </Button>
        {loading ? (
          <LoadingButton loading variant="outlined">
            Submit
          </LoadingButton>
        ) : (
          <Button variant="contained" onClick={addPermission}>
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarPermissao.btnSalvar}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddPermission;
